import React, { Fragment, useContext, useEffect, useState } from "react";

// Utils

// UI
import { Container, DateLayer, closeLayerFn, openLayerFn } from "../../Layout";
import { SUBS, SubMenu } from "../Pmr";
import {
  ListView,
  PeriodSetting,
  SelectArea,
  commonFileUpload,
  request551,
  request554,
  request555,
} from "../PmrLayout";

// Provider
import {
  AppContext,
  SET_ITEMSTATE,
  SET_PAGE_STATE,
  SocketCommand,
  socketManager,
} from "../../../components/AppProvider";
import { AlertLayer, ConfirmLayer } from "../../../components/UI/Dialog";
import { ScrollToTop } from "../../common/ScrollToTop/ScrollToTop";

import styled from "styled-components";
import { PostApi1913 } from "../../../modules/network/padoPost";
import {
  PeriodTypeChange,
  convertFormat,
  convertFormatString,
} from "../../../modules/utils/PeriodTypeChange";
import { requestGetNewPoint } from "../../../modules/utils/getNewPoint";
import { reLogin } from "../../common/AutoLogin/AutoLogin";
import SkeletonEdu from "../../common/Skeleton/SkeletonEdu";
import useTitle from "../../../modules/hooks/useTitle";

export default props => {
  useTitle("개인진료기록_교육자료");
  const { auth, userinfo, cfg, phonecfg, dispatch, pageState, itemState } =
    useContext(AppContext);
  // msgCount
  const [msgCount, setMsgCount] = useState("");

  // 서브메뉴 활성화 값 (기본 0)
  const sub = SUBS[2];
  // const sub = SUBS[1];

  const [periodIndex, setPeriodIndex] = useState(2);
  const [startDate, setStartDate] = useState(
    convertFormat(PeriodTypeChange("year", 1), "yyyyMMdd")
  );
  const [endDate, setEndDate] = useState(
    convertFormat(PeriodTypeChange("year", 0), "yyyyMMdd")
  );

  const [selectStartDate, setSelectStartDate] = useState("");
  const [selectEndDate, setSelectEndDate] = useState("");

  const [pdhType, setPdhType] = useState(3);
  const [hpCode, setHpCode] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [modalityName, setModalityName] = useState("");

  const [trsmId, setTrsmId] = useState();

  const [list, setList] = useState(null);
  const [hospitalList, setHospitalList] = useState("");
  const [modalityList, setModalityList] = useState("");
  const [trgtHsptList, setTrgtHsptList] = useState([]);

  // const [reload, setReload] = useState(1);

  const handleDate = (isStart, date) => {
    if (isStart === "1") {
      setSelectStartDate(date);
    } else {
      setSelectEndDate(date);
    }

    reloadList();
  };

  const handleAlertCB = () => {
    closeLayerFn($(".alert-layer"));
  };

  const openConfirmLayer = trsmId => {
    openLayerFn($(".confirm-layer"));
    setTrsmId(trsmId);
  };

  const fnConfirmLayer = () => {
    // bizDtlType : 0 진료자료, 1 기타자료, 2 교육자료 , 3 제증명
    socketManager(SocketCommand.FILE_UPLOAD, undefined, {
      type: "delete",
      userToken: userinfo.userToken.toString(),
      masterKeys: [
        { masterKey1: trsmId.toString(), masterKey2: "", masterKey3: "" },
      ],

      bizType: "PR",
      bizName: "개인진료기록",
      // bizDtlType: "3",
      bizDtlType: "2",
      viewYN: "Y",
      saveExtYN: "N",
      redirectURL: "",
      colorType: "PP",
      hsptSharYn: "N",
      bizSubType: "2",
    });
  };

  const fnCancelConfirmLayer = () => {
    closeLayerFn($(".confirm-layer"));
  };

  const reloadList = () => {
    if (periodIndex === 3) {
      if (selectStartDate == "" || selectEndDate == "") {
        setList(null);
      } else {
        request551(
          reLogin(auth, userinfo, dispatch),
          cfg,
          phonecfg,
          periodIndex,
          hpCode,
          modalityName,
          periodIndex != 3 ? startDate : selectStartDate,
          periodIndex != 3 ? endDate : selectEndDate,
          pdhType,
          "N",
          setList
        );
      }
    } else {
      request551(
        reLogin(auth, userinfo, dispatch),
        cfg,
        phonecfg,
        periodIndex,
        hpCode,
        modalityName,
        periodIndex != 3 ? startDate : selectStartDate,
        periodIndex != 3 ? endDate : selectEndDate,
        pdhType,
        "N",
        setList
      );
    }

    // requestGetNewPoint(userinfo, cfg, phonecfg, dispatch);
  };

  const socketConnection = (trsmId, fileExt) => {
    if (fileExt === "link") {
      socketManager(SocketCommand.NATIVE_ACTION, undefined, {
        actionType: "video",
        actionData: trsmId.toString(),
      });
    } else {
      if (phonecfg.phoneOS === "ANDROID") {
        // 안드로이드인 경우 2.0.30 이상
        if (parseInt(phonecfg.version.split(".")[2]) >= 41) {
          commonFileUpload(
            reloadList,
            userinfo,
            trsmId,
            3,
            "Y",
            "PR",
            "개인진료기록"
          );
        } else {
          // socketManager(SocketCommand.MULTI_FILE_DOWNLOAD, reloadList, {"userToken":userinfo.userToken, "masterKeys":[{"masterKey1":trsmId.toString(), "masterKey2":""}]});
          socketManager(SocketCommand.MULTI_FILE_DOWNLOAD, reloadList, {
            userToken: userinfo.userToken,
            trsmId: trsmId.toString(),
          });
        }
      } else {
        // IOS인 경우 2.0.31 이상
        if (parseInt(phonecfg.version.split(".")[2]) >= 21) {
          commonFileUpload(
            reloadList,
            userinfo,
            trsmId,
            3,
            "Y",
            "PR",
            "개인진료기록"
          );
        } else {
          // socketManager(SocketCommand.MULTI_FILE_DOWNLOAD, reloadList, {"userToken":userinfo.userToken, "masterKeys":[{"masterKey1":trsmId.toString(), "masterKey2":""}]});
          socketManager(SocketCommand.MULTI_FILE_DOWNLOAD, reloadList, {
            userToken: userinfo.userToken,
            trsmId: trsmId.toString(),
          });
        }
      }
    }
  };

  let userinfo2 = reLogin(auth, userinfo, dispatch);

  const request1913 = userinfo => {
    PostApi1913(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.result.sharHsptList.length > 0) {
            setTrgtHsptList(res.result.sharHsptList);
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    // 최초 초기화
    dispatch({ type: SET_PAGE_STATE, data: { type: "all", state: 0 } });
  }, []);

  useEffect(() => {
    if (pageState.share == 0) {
      $(".longTap").removeClass("none");
      $("#confirmCheck").hide();
      $(".check-box2").hide();
      $("input:checkbox").prop("checked", false);
    }
  }, [
    periodIndex,
    startDate,
    endDate,
    pdhType,
    hpCode,
    pageState.share,
    modalityName,
    hospitalList,
    pageState.reload,
    selectStartDate,
    selectEndDate,
  ]);

  useEffect(() => {
    dispatch({ type: SET_PAGE_STATE, data: { type: "reload", state: 1 } });
    // setReload(1);
    request554(
      userinfo2,
      cfg,
      phonecfg,
      periodIndex,
      periodIndex != 3 ? startDate : selectStartDate,
      periodIndex != 3 ? endDate : selectEndDate,
      pdhType,
      setHospitalList
    );
    request555(
      userinfo2,
      cfg,
      phonecfg,
      periodIndex,
      periodIndex != 3 ? startDate : selectStartDate,
      periodIndex != 3 ? endDate : selectEndDate,
      pdhType,
      setModalityList
    );
    request1913(userinfo2, cfg, phonecfg);
  }, [periodIndex, startDate, endDate, pdhType]);

  useEffect(() => {
    // if (reload === 1) {
    if (pageState.reload === 1) {
      // checkMsgCount(userinfo2, cfg, phonecfg, "9", "00000000", "99999999", setMsgCount);
      request551(
        userinfo2,
        cfg,
        phonecfg,
        periodIndex,
        hpCode,
        modalityName,
        periodIndex != 3 ? startDate : selectStartDate,
        periodIndex != 3 ? endDate : selectEndDate,
        pdhType,
        "N",
        setList
      );

      if (pageState.share == 0) {
        $(".longTap").removeClass("none");
        $("#confirmCheck").hide();
        $(".check-box2").hide();
        $("input:checkbox").prop("checked", false);
      }
      dispatch({ type: SET_PAGE_STATE, data: { type: "reload", state: 0 } });
      // setReload(0)
    }
  }, [pageState.reload]);

  useEffect(() => {
    if (itemState.reload) {
      request551(
        userinfo2,
        cfg,
        phonecfg,
        periodIndex,
        hpCode,
        modalityName,
        startDate,
        endDate,
        pdhType,
        "N",
        setList
      );

      if ($(".confirm-layer").hasClass("on")) {
        closeLayerFn($(".confirm-layer"));
      }

      requestGetNewPoint(userinfo, cfg, phonecfg, dispatch);

      dispatch({
        type: SET_ITEMSTATE,
        data: { type: "COMPLETE" },
      });
    }
  }, [itemState.reload]);

  useEffect(() => {
    if (periodIndex === 0) {
      setStartDate(convertFormat(PeriodTypeChange("year", 1), "yyyyMMdd"));
    } else if (periodIndex === 1) {
      setStartDate(convertFormat(PeriodTypeChange("year", 2), "yyyyMMdd"));
    } else if (periodIndex === 2) {
      setStartDate(convertFormat(PeriodTypeChange("year", 3), "yyyyMMdd"));
    } else {
      if (selectStartDate != "") {
        $("#dateFrom").val(convertFormatString(selectStartDate, "yyyy.MM.dd"));
        setStartDate(selectStartDate);
      } else {
        setStartDate("");
      }
      if (selectEndDate != "") {
        $("#dateTo").val(convertFormatString(selectEndDate, "yyyy.MM.dd"));
        setEndDate(selectEndDate);
      } else {
        setEndDate("");
      }
    }

    if (periodIndex != 4) {
      if (endDate != convertFormat(PeriodTypeChange("month", 0), "yyyyMMdd")) {
        setEndDate(convertFormat(PeriodTypeChange("month", 0), "yyyyMMdd"));
      }
    }
  }, [periodIndex]);

  useEffect(() => {
    request551(
      userinfo2,
      cfg,
      phonecfg,
      periodIndex,
      hpCode,
      modalityName,
      periodIndex != 3 ? startDate : selectStartDate,
      periodIndex != 3 ? endDate : selectEndDate,
      pdhType,
      "N",
      setList
    );
  }, [
    startDate,
    endDate,
    pdhType,
    periodIndex,
    hpCode,
    modalityName,
    selectStartDate,
    selectEndDate,
  ]);

  return (
    <Fragment>
      <ScrollToTop />
      <Container
        Title="교육자료"
        msgCount={msgCount}
        goToUrl="/"
        color="purple">
        <div className="contents sub priv">
          {/* subTabMenu */}
          <SubMenu code={sub.code} />
          {/* /subTabMenu */}

          {/* 검색폼 */}
          <div className="pr-section">
            <div className="sub-contents" style={{ paddingBottom: "20px" }}>
              {/* <div className="half-round-bgbox"> */}
              {/* 기간 설정 */}
              <PeriodSetting setPeriodIndex={setPeriodIndex} />
              {/* / 기간설정 */}

              {/* <SelectArea show="show" hospitalList={hospitalList} hospitalName={hospitalName} setHpCode={setHpCode} trgtHsptList={trgtHsptList}/> */}
              <SelectArea
                modalityList={modalityList}
                setModalityName={setModalityName}
                hospitalList={hospitalList}
                hospitalName={hospitalName}
                setHpCode={setHpCode}
                trgtHsptList={trgtHsptList}
              />
              {/* <BtnSharedMode shareMode={shareMode} setShareMode={setShareMode} handleAlert={handleAlert} /> */}
              {/* </div> */}
            </div>
          </div>
          {/* / 검색폼 */}

          {/* FILE UPLOAD 배포대기 2022-06-23 */}
          {/* {
                    (list != null && list.length > 0) &&
                        <PillBtnArea>
                            {
                                pageState.share === 0
                                    ?   <BtnTypePill text={"선택"} onClick={()=>clickBtnEvent()} />
                                    :   <Fragment>
                                            <BtnTypePill text="취소" id="restoreMode" onClick={()=>resetChecked()} />
                                            <BtnTypePill text="전체선택" id="checkAll" onClick={()=>checkedAll()} />
                                            <BtnTypePill text="전체해제" id="unCheckAll" display="none" onClick={()=>unCheckedAll()} />
                                        </Fragment>
                            }
                        </PillBtnArea>
                } */}
          {/* FILE UPLOAD 배포대기 2022-06-23 */}

          <div className="sub-contents" style={{ paddingTop: "0px" }}>
            {list != null ? (
              <ListView
                type="TREAT"
                pdhType={pdhType}
                list={list}
                userToken={userinfo.userToken}
                openConfirmLayer={openConfirmLayer}
                returnUrl="/pmr/treatEducation"
                socketConnection={socketConnection}
                bizSubType="2"
              />
            ) : (
              <SkeletonEdu />
            )}
          </div>
        </div>
      </Container>
      <DateLayer handleDate={handleDate} />
      <AlertLayer
        priv="priv"
        title="서비스 준비중"
        msg="서비스 준비중 입니다."
        handleConfirmCB={handleAlertCB}
      />
      <ConfirmLayer
        priv="priv"
        title="개인진료기록 삭제"
        msg="삭제한 파일은 다시 복구할 수 없습니다. <br /> 정말 삭제 하겠습니까?"
        handleCancelCB={fnCancelConfirmLayer}
        handleConfirmCB={fnConfirmLayer}
      />
    </Fragment>
  );
};

const SelectAllText = styled.div`
font-weight: 400;
font-size: 14px;
line-height: 17px;
color: #000000;

display: inline-block;
box-sizing: border-box;
flex-direction: column;
`

const SelectAllSubText = styled.div`
font-weight: 400;
font-size: 0.625rem;
line-height: 16px;
color: #6A62E6;

display: inline-block;
box-sizing: border-box;
flex-direction: column;

padding-left: 8px;
`